import { string, object, ref } from "yup";

export const createPasswordsSchema = (t) => object().shape({
  password: string().required(t('validation.field_empty')),
  confirmPassword: string()
    .oneOf([ref('password')], t('validation.passwords_mismatch'))
    .required(t('validation.field_empty'))
});

const passwordsSchema = object().shape({
  password: string().required("Champs vide"),
  confirmPassword: string()
    .oneOf([ref('password')], "Les deux champs doivent être identiques")
    .required("Champs vide")
});

export default passwordsSchema;
